import React from 'react';

const FormSection = ({ 
  title, 
  children, 
  actions,
  className = '',
  ...props 
}) => {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-3 flex flex-col ${className}`} {...props}>
      {title && (
        <div className="flex items-center justify-between bg-gray-100 -mx-3 -mt-3 px-3 py-2 mb-2 border-b border-gray-200 rounded-t-lg">
          <h2 className="text-xs font-semibold text-gray-700 uppercase tracking-wide">{title}</h2>
          {actions && <div className="ml-4">{actions}</div>}
        </div>
      )}
      {!title && actions && (
        <div className="flex justify-end mb-2">
          {actions}
        </div>
      )}
      <div className="flex-1 flex flex-col">
        {children}
      </div>
    </div>
  );
};

export default FormSection;
